/*
 * Copyright (c) 2024. Dave van Rijn Development
 */

import React, {CSSProperties, useContext, useMemo} from 'react';
import Loader from "./loader";
import {ControlContext} from "../util/controlContext";

interface Props {
    label?: string,
    baseColor?: string,
    thickness?: string,
    size?: string,
    trackColor?: string,
    className?: string,
    loaderClassName?: string,
    labelClassName?: string,
    active: boolean,
    disableBackground?: boolean,
    loaderStyle?: CSSProperties;
    position?: 'absolute' | 'fixed' | 'relative';
}

export default function LoaderController(props: Props) {
    const context = useContext(ControlContext);
    const baseColor = useMemo(() => {
        if (!!props.baseColor) return props.baseColor;
        return context.baseColor;
    }, [props.baseColor, context.baseColor]);
    const defaultProps: Props = {
        ...props,
        trackColor: props.trackColor ?? 'transparent',
        size: props.size ?? '5rem',
        thickness: props.thickness ?? '.2rem',
        position: props.position ?? 'absolute',
    }

    if (!props.active) return null;
    return (
        <Loader baseColor={baseColor} trackColor={defaultProps.trackColor!} className={defaultProps.className}
                loaderClassName={defaultProps.loaderClassName} labelClassName={defaultProps.labelClassName}
                contextStyle={context} disableBackground={defaultProps.disableBackground}
                loaderStyle={defaultProps.loaderStyle} position={defaultProps.position!} size={defaultProps.size}
                thickness={defaultProps.thickness} label={defaultProps.label}/>
    )
}